import React from "react";
import { cn } from "@/lib/utils";

// Variants map onto the admin panel's .btn-* classes.
const VARIANTS = {
  default: "",
  primary: "btn-primary",
  accent: "btn-accent",
  success: "btn-success",
  destructive: "btn-destructive",
  danger: "btn-danger",
  ghost: "btn-ghost",
};

const SIZES = {
  xs: "px-2.5 py-1 text-xs rounded-lg gap-1",
  sm: "px-3.5 py-2 text-xs rounded-xl gap-1.5",
  md: "px-4 py-2.5 text-sm rounded-xl gap-2",
  lg: "px-5 py-3 text-sm rounded-2xl gap-2",
  icon: "p-2 rounded-xl",
};

export function Button({ variant = "default", size = "sm", icon, loading = false, fullWidth, className, children, disabled, type = "button", ...rest }) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={cn("btn", VARIANTS[variant], SIZES[size], fullWidth && "w-full", className)}
      {...rest}
    >
      {loading ? (
        <span className="w-3.5 h-3.5 border-2 border-slate-300/60 border-t-current rounded-full animate-spin" />
      ) : icon && <span className="shrink-0 inline-flex">{icon}</span>}
      {children}
    </button>
  );
}
